import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

export const PRICE_VAT_DISCLAIMER_TEXT =
  'Los precios indicados no incluyen IVA.';

/**
 * Aviso legal estándar en propuestas comerciales con montos en USD.
 */
const PriceVatDisclaimer = ({ sx, align = 'center', variant = 'body2' }) => (
  <Box
    sx={{
      maxWidth: 720,
      mx: 'auto',
      mt: 2,
      textAlign: align,
      ...sx,
    }}
  >
    <Typography variant={variant} color="textSecondary" fontStyle="italic">
      {PRICE_VAT_DISCLAIMER_TEXT}
    </Typography>
  </Box>
);

PriceVatDisclaimer.propTypes = {
  sx: PropTypes.object,
  align: PropTypes.oneOf(['left', 'center', 'right', 'inherit']),
  variant: PropTypes.string,
};

export default PriceVatDisclaimer;
